
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Paragraph } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  Cards act as an entry point to more detailed information. A card is container
  for a few short, related pieces of information. It roughly resembles a playing
  card in size and shape, and is intended as a linked, short representation of a
  conceptual unit.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <p>{`Card layouts can vary to support the types of content they contain.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Constraint`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Thumbnail`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Optional`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Title`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Mandatory`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Description`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Optional`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Meta`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Optional`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Tags`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Optional`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Infos`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Optional`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`Browsing for information (as opposed to searching)`}</li>
      <li parentName="ul">{`Grouping heterogeneous types of content`}</li>
      <li parentName="ul">{`Allowing users to scan through content in small portions`}<ul parentName="li">
          <li parentName="ul">{`To display structured content`}</li>
          <li parentName="ul">{`To make information discoverable`}</li>
        </ul></li>
      <li parentName="ul">{`The user goals that the card-based web design best responds to:`}<ul parentName="li">
          <li parentName="ul">{`scrolling through`}</li>
          <li parentName="ul">{`scanning through`}</li>
          <li parentName="ul">{`browsing through`}</li>
        </ul></li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`Searching for information (as opposed to browsing).`}</li>
      <li parentName="ul">{`On small screen display avoid using too many cards as they force users to scroll down and rely on their short-term memory. This creates a cognitive overload, a negative user experience.`}</li>
    </ul>
    <h2>{`DO's`}</h2>
    <ul>
      <li parentName="ul">{`Use cards to emphasize on contents`}</li>
      <li parentName="ul">{`Only display the most relevant information on each card
illustration: card with a thumbnail, title, description`}</li>
      <li parentName="ul">{`Keep the amount of links on the cards as low as possible`}</li>
    </ul>
    <h2>{`DON'Ts`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Overuse cards`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Limit the amount of cards to small groups of items`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Limit to 3-4 cards within a row`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Use cards as an image gallery, use `}<Link to="/ec/components/media/gallery/usage" mdxType="Link">{`gallery`}</Link>{` instead.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Use cards to display images or video, use `}<Link to="/ec/components/media/media-container/usage" mdxType="Link">{`media container`}</Link>{` instead.`}</p>
        <p parentName="li">{`illustration: card with multiple meta, tags`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Display too many links on a cards, the main and ideally only action on card should remain to navigate to the content it represent.`}</p>
      </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;